'use client';

import { useTranslations } from 'next-intl';
import { TrackedAnchor } from '@/components/ancher/tracked-anchor';
import { TRACKED_EVENT_POSITION } from '@/constants/gtag';
import {
  alwaysBreakRichTextTags,
  customRichTextTags,
} from '../main-responsive';
import MobileSectionEclipse from './mobile-section-eclipse';
import DesktopSectionEclipse from './desktop-section-eclipse';

export function ReanalysisLink() {
  const t = useTranslations('Main.reanalysis');
  return (
    <TrackedAnchor
      href={t('href')}
      target="_blank"
      label="main-reanalysis_view-cases"
      position={TRACKED_EVENT_POSITION.MAIN_CONTENT}
      className="inline-flex min-h-10 items-center justify-center rounded-full bg-white px-3 py-3.5 text-center text-[12px] font-semibold leading-3 text-3b-text-primary hover:bg-[#ff142d] hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white xl:min-h-[71px] xl:px-[30px] xl:py-4 xl:text-[20px] xl:font-bold xl:leading-normal"
    >
      {t('cta')}
    </TrackedAnchor>
  );
}

export function ReanalysisFallback() {
  const t = useTranslations('Main.reanalysis');
  return (
    <div className="relative isolate flex min-h-[600px] flex-col items-center justify-center gap-6 overflow-hidden bg-[#0d0e10] px-6 py-12 text-center text-white xl:min-h-[680px]">
      <DesktopSectionEclipse half="upper" className="-z-10" />
      <MobileSectionEclipse half="upper" className="-z-10" />
      <h2 className="text-[24px] font-medium leading-8 text-white/70">
        {t.rich('question', customRichTextTags)}
      </h2>
      <h3 className="text-[24px] font-semibold leading-8 tracking-[-0.464px] xl:text-[48px] xl:leading-[56px] xl:tracking-[-1.072px]">
        {t.rich('title', alwaysBreakRichTextTags)}
      </h3>
      <blockquote className="max-w-[300px] break-keep text-[12px] font-medium leading-[18px] text-white/80 xl:max-w-[757px] xl:text-[20px] xl:leading-8">
        <p>{t.rich('quote', customRichTextTags)}</p>
        <footer className="mt-6">{t('author')}</footer>
      </blockquote>
      <ReanalysisLink />
    </div>
  );
}
